/**
 * Словарь интерфейса: русский (канонический язык для значений фильтров в БД).
 * Меняйте тексты здесь — они подхватятся во всём приложении.
 */
export default {
  // Шапка и общее
  header_filters: 'Фильтры',
  header_done: 'Применить',
  filters_close: 'Закрыть фильтры',
  header_city_title: 'Выбор города',
  header_language: 'Язык',
  header_outreach: 'Рассылка',
  header_outreach_title: 'Дашборд телеграм-рассылки (админ)',
  header_debug: 'Debug',
  header_debug_title: 'Debug-режим карты (как ?debug= в адресе): служебные данные геокодинга, прежние координаты и скрытые объявления',
  loading: 'Загрузка фильтров…',

  // Плейсхолдеры и общие подписи
  placeholder_min: 'мин',
  placeholder_max: 'макс',
  common_any_value: 'Любое значение',
  common_yes: 'Да',
  common_no: 'Нет',
  common_any_type: 'Любой тип',
  common_any_type_plot: 'Любой тип участка',
  common_any_type_house: 'Любой тип дома',
  common_any_layout: 'Любая планировка',
  common_any_bathroom: 'Любой санузел',
  common_any_renovation: 'Любой ремонт',
  common_gas_any: 'С газом и без',
  common_any_heating: 'Любое отопление',
  common_any_purpose: 'Любое назначение',
  common_any_location: 'Любое расположение',
  common_any_finishing: 'Любая отделка',
  common_any_facade: 'Любой фасад',
  common_any_parking: 'Любая парковка',
  common_any_stage: 'Любая стадия',
  common_any_class: 'Любой класс',

  // Подписи блоков фильтров
  filters_price: 'Цена',
  filters_commission_up_to: 'Комиссия до',
  filters_rooms: 'Количество комнат',
  filters_area_total: 'Общая площадь, м²',
  filters_area_living: 'Жилая площадь, м²',
  filters_area_kitchen: 'Площадь кухни, м²',
  filters_area_usable: 'Полезная площадь, м²',
  filters_plot_area: 'Площадь участка, сотки',
  filters_floor: 'Этаж',
  filters_floors_total: 'Этажность дома',
  filters_ceiling: 'Высота потолков, м',
  filters_year_built: 'Год постройки/сдачи',
  filters_housing_type: 'Тип жилья',
  filters_building_type: 'Тип строения',
  filters_layout: 'Планировка',
  filters_bathroom: 'Санузел',
  filters_furnished: 'Меблирована',
  filters_renovation: 'Ремонт',
  filters_gas: 'Газ',
  filters_features_inside: 'В квартире есть',
  filters_features_inside_commercial: 'В помещении есть',
  filters_features_nearby: 'Рядом есть',
  filters_plot_features: 'В доме / на участке есть',
  filters_house_conditions: 'Состояние дома',
  filters_water: 'Вода',
  filters_heating: 'Отопление',
  filters_communications: 'Коммуникации',
  filters_realty_type: 'Тип недвижимости',
  filters_house_location: 'Расположение',
  filters_land_purpose: 'Назначение',
  filters_plot_type: 'Тип участка',
  filters_garage_type: 'Тип',
  filters_garage_purpose: 'Назначение',
  filters_commercial_location: 'Расположение',
  filters_commercial_has_plot: 'Участок',
  filters_electricity: 'Электричество',
  filters_has_parking: 'Наличие парковки',
  filters_house_type: 'Тип дома',
  filters_housing_class: 'Класс жилья',
  filters_blocks_count: 'Количество корпусов',
  filters_finishing: 'Отделка',
  filters_facade: 'Фасад',
  filters_parking_type: 'Парковка',
  filters_construction_stage: 'Этап строительства',
  filters_parking_slots_from: 'Количество машиномест от',
  filters_installment: 'Рассрочка',
  filters_mortgage: 'Ипотека',

  // Баллун
  balloon_no_photo: 'Нет фото',
  carousel_prev: 'Назад',
  carousel_next: 'Вперёд',
  debug_section_title: 'Debug данные',
  debug_description: 'Описание',
  debug_geocoded_by: 'Источник геокодинга',
  debug_geocoded: 'Geocoded',
  debug_landmarks_anomalies: 'Landmarks anomalies',
  debug_landmarks_approved: 'Landmarks approved',
  debug_geocoding_requests: 'Geocoding requests',
  debug_change_link: 'Персональная ссылка изменения локации',
  debug_regeocode_button: 'Regeocode',
  debug_regeocode_status_running: 'Перегеокодирование...',
  debug_regeocode_status_done: 'Готово: геоданные обновлены',
  debug_regeocode_status_error: 'Ошибка перегеокодирования',
  debug_regeocode_status_unchanged: 'Координаты не изменились',
  debug_regeocode_flash_unchanged: 'Координаты не изменились',
  debug_toggle_on: 'Debug-режим включён',
  debug_toggle_off: 'Debug-режим выключен',

  // Режим изменения локации (?change=...)
  change_button: 'Изменить локацию',
  change_pick_hint: 'Кликните по карте, чтобы выбрать новую локацию объявления',
  change_cancel: 'Отмена',
  change_confirm_title: 'Сохранить новую локацию?',
  change_confirm_hint: 'Точку можно перетащить для уточнения',
  change_confirm: 'Подтвердить',
  change_saving: 'Сохранение...',
  change_save_done: 'Локация обновлена',
  change_save_error: 'Не удалось сохранить локацию',
  change_hide_button: 'Скрыть',
  change_show_button: 'Показать',
  change_hide_confirm_title: 'Скрыть объявление?',
  change_show_confirm_title: 'Показать объявление?',
  change_hide_confirm_hint: 'Объявление перестанет отображаться на карте у обычных пользователей',
  change_show_confirm_hint: 'Объявление снова будет видно всем',
  change_hide_done: 'Объявление скрыто',
  change_show_done: 'Объявление показано',
  change_hide_error: 'Не удалось изменить видимость',
  balloon_hidden_banner: 'Объявление скрыто',

  // Авторизация по одноразовой ссылке
  auth_menu_title: 'Профиль',
  auth_logout: 'Выйти',
  auth_login_success: 'Вы вошли — ваши объявления подсвечены оранжевым. Откройте своё объявление, чтобы изменить локацию или скрыть его',
  auth_login_success_no_hide: 'Вы вошли — ваши объявления подсвечены оранжевым. Откройте своё объявление, чтобы изменить его локацию',
  auth_login_error: 'Ссылка для входа недействительна или устарела',
  auth_logged_out: 'Вы вышли',

  // Правка своего объявления автором (вход по персональной login-ссылке)
  author_card_hint: 'Это ваше объявление: можно изменить локацию или скрыть его с карты',
  author_card_hint_no_hide: 'Это ваше объявление: можно изменить его локацию',
  author_save_done: 'Спасибо! Локация вашего объявления обновлена',
  author_hide_done: 'Объявление скрыто с карты. Вернуть его можно кнопкой «Показать»',
  author_session_expired: 'Не удалось сохранить: срок входа истёк. Откройте ссылку из сообщения ещё раз',

  // Города (для меню выбора; в API передаётся каноническое имя из CITIES)
  city_andijan: 'Андижан',
  city_bukhara: 'Бухара',
  city_guliston: 'Гулистон',
  city_jizzakh: 'Джизак',
  city_karshi: 'Карши',
  city_navoi: 'Наваи',
  city_namangan: 'Наманган',
  city_nukus: 'Нукус',
  city_samarkand: 'Самарканд',
  city_tashkent: 'Ташкент',
  city_termez: 'Термез',
  city_urgench: 'Ургенч',
  city_fergana: 'Фергана',

  // Значения опций вынесены в locales/opt/*.js
}
